import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Exit_Survey_Response } from "@/interfaces/api/survey/api_response_types"
import { checkExitSurvey } from "../requests/survey"

type ExitSurveyOptions = Omit<
  UseQueryOptions<API_Data_Exit_Survey_Response, API_Error, API_Data_Exit_Survey_Response, ['checkExitSurvey', string]>,
  'queryKey' | 'queryFn'
>

export const useExitSurvey = (locale: string, options?: ExitSurveyOptions) => 
  useQuery<API_Data_Exit_Survey_Response, API_Error, API_Data_Exit_Survey_Response, ['checkExitSurvey', string]>({
    queryKey: ['checkExitSurvey', locale],
    retry: false,
    queryFn: () => checkExitSurvey(locale),
    ...options
  })